<app-header></app-header>
<main class="main">
  <router-outlet></router-outlet>
</main>
<app-flash-message></app-flash-message>
<ngx-guided-tour></ngx-guided-tour>
<app-footer></app-footer>
